import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Landing from './pages/Landing';
import Quiz from './pages/Quiz';
import Results from './pages/Results';
import Activities from './pages/Activities';
import Register from './pages/Register';
import Login from './pages/Login';
import CheckEmail from './pages/CheckEmail';
import Welcome from './pages/Welcome';
import Loading from './pages/Loading';
import History from './pages/History';
import SavedActivities from './pages/SavedActivities';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import { initAnalytics } from './lib/analytics';
import './index.css';

function App() {
  initAnalytics();
  // Restore session from localStorage if keep signed in was checked
  if (localStorage.getItem('carpeKeepSignedIn') === 'true') {
    const userId = localStorage.getItem('carpeUserId');
    const email = localStorage.getItem('carpeUserEmail');
    const token = localStorage.getItem('carpeAccessToken');
    if (userId && email && token) {
      sessionStorage.setItem('carpeUserId', userId);
      sessionStorage.setItem('carpeUserEmail', email);
      sessionStorage.setItem('carpeAccessToken', token);
      const profile = localStorage.getItem('carpeWonderProfile');
      const destinations = localStorage.getItem('carpeSavedDestinations');
      const reshufflePool = localStorage.getItem('carpeReshufflePool');
      const enrichTeasers = localStorage.getItem('carpeEnrichTeasers');
      const enrichFacts = localStorage.getItem('carpeEnrichFacts');
      if (profile) sessionStorage.setItem('carpeWonderProfile', profile);
      if (destinations) {
        sessionStorage.setItem('carpeSavedDestinations', destinations);
        sessionStorage.setItem('carpeReturningUser', 'true');
      }
      if (reshufflePool) sessionStorage.setItem('carpeReshufflePool', reshufflePool);
      if (enrichTeasers) sessionStorage.setItem('carpeEnrichTeasers', enrichTeasers);
      if (enrichFacts) sessionStorage.setItem('carpeEnrichFacts', enrichFacts);
      
    }
  }

  return (
    <BrowserRouter> 
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/quiz" element={<Quiz />} />
        <Route path="/results" element={<Results />} />
        <Route path="/activities" element={<Activities />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/welcome" element={<Welcome />} />
        <Route path="/check-email" element={<CheckEmail />} />
        <Route path="/loading" element={<Loading />} />
        <Route path="/history" element={<History />} />
        <Route path="/saved-activities" element={<SavedActivities />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;